/* cart-sync.js (click interception + href rewrite + Alpine refresh + logs)
   - Intercepts cross-domain clicks
   - Rewrites outbound link hrefs with cartData on page load
   - On arrival, clears destination cart and bulk-adds items if any
   - Calls Alpine app.updateCart(false,false) to refresh badge/drawer
   - Strips param from URL after rebuild
   - Logs each step to console for debugging
*/

(function () {
  var DOMAINS = ['richesonart.com', 'wholesale.decoart.com'];

  function normalizeHost(h) { return (h || '').replace(/^www\./, ''); }
  function isTargetDomain(href) {
    try {
      var url = new URL(href, window.location.origin);
      var host = normalizeHost(url.host);
      var here = normalizeHost(window.location.host);
      var match = host && host !== here && DOMAINS.indexOf(host) !== -1;
      return match;
    } catch (err) {
      console.warn('[cart-sync] isTargetDomain error', err);
      return false;
    }
  }

  async function getCart() {
    var res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Cart fetch failed');
    var json = await res.json();
    return json;
  }

  function encodeItems(items) {
    var compact = (items || []).map(function (i) {
      return { id: i.id, quantity: i.quantity };
    });
    return encodeURIComponent(JSON.stringify(compact));
  }

  function decodeItems(param) {
    try {
      var decoded = JSON.parse(decodeURIComponent(param));
      return decoded;
    } catch (err) {
      console.warn('[cart-sync] decodeItems error', err);
      return null;
    }
  }

  // Rewrite outbound link hrefs with current cartData
  async function rewriteOutboundLinks() {
    try {
      var cart = await getCart();
      var encoded = encodeItems(cart.items || []);
      document.querySelectorAll('a[href]').forEach(link => {
        if (isTargetDomain(link.href)) {
          var url = new URL(link.href, window.location.origin);
          url.searchParams.set('cartData', encoded);
          link.href = url.toString();
        }
      });
    } catch (err) {
      console.warn('[cart-sync] rewriteOutboundLinks failed', err);
    }
  }

  // Intercept outbound clicks and append fresh cartData
  function attachClickHandler() {
    document.addEventListener('click', async function (e) {
      var link = e.target.closest('a[href]');
      if (!link) return;

      var href = link.getAttribute('href');
      if (!href || !isTargetDomain(href)) return;

      e.preventDefault();

      try {
        var cart = await getCart();
        var encoded = encodeItems(cart.items || []);
        var url = new URL(href, window.location.origin);
        url.searchParams.set('cartData', encoded);
        window.location.href = url.toString();
      } catch (err) {
        console.warn('[cart-sync] Failed to attach cartData', err);
        window.location.href = href; // fallback
      }
    }, { capture: true });
  }

  // On arrival, rebuild cart from snapshot
  async function rebuildOnArrival() {
    var params = new URLSearchParams(window.location.search);
    var incoming = params.get('cartData');
    if (incoming === null) {
      return;
    }

    var items = decodeItems(incoming);
    if (!items) {
      return;
    }

    try {
      var clearRes = await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });

      if (Array.isArray(items) && items.length > 0) {
        var addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items })
        });
      } else {
      }

      // Refresh the cart UI using Alpine's app() instance
      const root = document.querySelector('html[x-data]');
      if (root && window.Alpine && Alpine.$data(root) && typeof Alpine.$data(root).updateCart === 'function') {
        Alpine.$data(root).updateCart(false, false);
      } else {
        console.warn('[cart-sync] Alpine app.updateCart not available');
      }

    } catch (err) {
      console.warn('[cart-sync] rebuildOnArrival error', err);
    }

    // Strip param from URL
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('cartData');
      window.history.replaceState({}, document.title, url.toString());
    } catch (err) {
      console.warn('[cart-sync] Failed to strip cartData', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      rewriteOutboundLinks();
      attachClickHandler();
      rebuildOnArrival();
    });
  } else {
    rewriteOutboundLinks();
    attachClickHandler();
    rebuildOnArrival();
  }
})();
